<template>
  <div class="bghover">
    <div>
      <h2>污染物浓度变化</h2>
    </div>

    <div style="text-align: left">
      <el-collapse accordion>
        <el-collapse-item>
          <template slot="title">
            <span style="color: #f56c6c"
              >什么是气象调整方法？<i class="header-icon el-icon-info"></i
            ></span>
          </template>
          <div>
            基于2011年3月到2019年2月累积八年的小时气象数据，对“2+66”城市分别构造基准气象条件，在此基准气象条件下计算各季节污染物的浓度，通过控制气象条件，捕捉潜在排放量的变化。具体来说，我们采用核估计方法，对各年份和季度的污染与气象数据建立调整模型，将该模型作用于八年基准气象的经验分布函数，计算调整均值。
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div style="text-align: left; margin-top: 15px">
      <el-form class="textAlignLeft">
        <el-form-item label="评估污染物" class="marginZero">
          <el-radio-group v-model="assessPull" @change="pullChange">
            <el-radio label="PM2.5">PM2.5</el-radio>
            <el-radio label="PM10">PM10</el-radio>
            <el-radio label="SO2">SO2</el-radio>
            <el-radio label="NO2">NO2</el-radio>
            <el-radio label="CO">CO</el-radio>
            <el-radio label="O3">O3</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="显示数据（可多选）" class="marginZero">
          <el-checkbox-group
            v-model="assessPullContent"
            @change="assessPullContentChange"
          >
            <el-checkbox label="raw">气象调整前</el-checkbox>
            <el-checkbox label="data">气象调整后</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>

    <!-- 图像下载 -->
    <div>
      <el-row type="flex" justify="end">
        <el-button
          type="success"
          icon="el-icon-download"
          @click="downloadImage"
          >图像下载</el-button
        >
      </el-row>
    </div>

    <div id="city-pull-chart-canvas">
      <el-row>
        <div
          class="city-pull"
          id="city-pull-chart"
          :style="{ height: eleheight + 'px' }"
        ></div>
      </el-row>

      <!-- <el-row>
        <div
          class="city-pull"
          id="city-pull-rank-chart"
          :style="{ height: eleheight + 'px' }"
        ></div>
      </el-row> -->
    </div>
  </div>
</template>

<style scoped>
/* .el-button {
  border-width: 0px;
  color: black;
  padding: 0 10px;
  margin: 0;
  background: transparent;
} */

.el-row {
  margin-bottom: 15px;
}
.el-divider {
  margin: 0;
  margin-bottom: 10px;
}

.el-divider {
  margin: 0;
  margin-bottom: 10px;
}

.city-pull {
  padding-top: 10px;
}
</style>

<script>
import { getPullStand } from "@/assets/js/my-utils.js";

import { GenerateMapImgFromDom } from "@/assets/js/utils-map.js";

export default {
  name: "CityPullMaps",
  data() {
    return {
      assessPull: "PM2.5",
      assessPullContent: ["raw"],
      eleheight: 380,
      chart: "",
      screenState: true, //默认竖屏
      isMobile: false,
      chart: [],
      cityname_en: "",
      cityname: "",
      chart_line_data: [],
      chart_rank_data: [], //全部的城市的数据
    };
  },
  props: {
    assesscity: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return [
          ["直辖市", "北京"],
          ["直辖市", "天津"],
        ];
      },
    },

    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  methods: {
    downloadImage() {
      let imageDom = document.getElementById("city-pull-chart-canvas");

      let title;
      let pull = this.assessPull;
      let content = this.assessPullContent;

      if (content.length > 1) {
        title = pull + "各季度经气象调整前后浓度变化";
      } else if (content[0] == "raw") {
        title = pull + "各季度原始浓度变化";
      } else {
        title = pull + "经气象调整后各季度浓度变化";
      }

      GenerateMapImgFromDom(imageDom, title + ".png");
    },

    pullChange(pull) {
      //   污染物发生变化
      this.assessPull = pull;

      this.chart_line_data = [];
      this.chart_rank_data = [];
      this.updatePullCharts();
    },
    assessPullContentChange(content) {
      this.chart_line_data = [];
      this.chart_rank_data = [];
      this.assessPullContent = content;
      this.updatePullCharts();
    },
    drawPullData() {
      // 绘制line
      const that = this;

      let axiosPosts = [];
      this.assesscity.forEach((element) => {
        let hasCityData = false;
        for (let i = 0; i < that.chart_line_data.length; i++) {
          if (that.chart_line_data[i].city == element[1]) {
            hasCityData = true;
          }
        }

        if (!hasCityData) {

          if(element[2]){
            let url = "/AQAssess/getCityPull/" + element[2] + "/" + this.assessPull;
            axiosPosts.push(
              // that.$axios.post("/AQAssess/getData.php", {
              //   database: "city_pull",
              //   pull: that.assessPull,
              //   city_en: element[2],
              // })
              that.$axios.get(url)
            );
          }

          
        }
      });
      let line_data = [];

      if (axiosPosts.length > 0) {
        this.$axios
          .all(axiosPosts)
          .then((res) => {
            res.forEach((re) => {
              console.log(re)
              // let city_en = JSON.parse(re.config.data)["city_en"];
              let city_en = re.config.url.split("/")[3];

              let city = "";
              for (let i = 0; i < that.assesscity.length; i++) {
                if (that.assesscity[i][2] == city_en) {
                  city = that.assesscity[i][1];
                  break;
                }
              }

              that.chart_line_data.push({
                city: city,
                data: re.data,
              });
            });
            

            that.assesscity.forEach((element) => {
              for (let i = 0; i < that.chart_line_data.length; i++) {
                if (that.chart_line_data[i].city === element[1]) {
                  line_data.push(that.chart_line_data[i]);
                }
              }
            });

            that.drawCityPullLineChart(
              that.chart[0],
              line_data,
              that.assessPull,
              that.assessPullContent
            );
          });

          // .catch((e) => {
          //   this.$message({
          //     type: "info",
          //     message: "获取污染物浓度排名数据失败",
          //   });
          // });
      } else {
        that.assesscity.forEach((element) => {
          for (let i = 0; i < that.chart_line_data.length; i++) {
            if (that.chart_line_data[i].city === element[1]) {
              line_data.push(that.chart_line_data[i]);
            }
          }
        });

        that.drawCityPullLineChart(
          that.chart[0],
          line_data,
          that.assessPull,
          that.assessPullContent
        );
      }
    },
    drawPullRankData() {
      // 绘制排名
      const that = this;

      let database = "city_pull_rank_both";
      let axiosPosts = [];
      this.assesscity.forEach((element) => {
        axiosPosts.push(
          that.$axios.post("/AQAssess/getData.php", {
            database: database,
            pull: that.assessPull,
            city_en: element[2],
          })
        );
      });

      that.chart_rank_data = [];
      that.$axios.all(axiosPosts).then((res) => {
        // console.log("==========");
        // console.log(res);
        res.forEach((re) => {
          // 找到城市中文
          let city_en = JSON.parse(re.config.data)["city_en"];
          let city = "";

          for (let i = 0; i < that.assesscity.length; i++) {
            if (that.assesscity[i][2] == city_en) {
              city = that.assesscity[i][1];
              that.chart_rank_data.push({
                city: city,
                raw: JSON.parse(re.data[0]),
                data: JSON.parse(re.data[1]), //调整后
              });
              break;
            }
          }
        });

        that.drawCityPullRankChart(
          that.chart[1],
          that.chart_rank_data,
          that.assessPull,
          that.assessPullContent
        );
      });
    },
    updatePullCharts() {
      this.chart[0].showLoading();
      // this.chart[1].showLoading();
      this.drawPullData();
      // this.drawPullRankData();
    },

    drawCityPullLineChart(chart, data, pull, content = ["raw"]) {
      const that = this;
      let series = [];
      let axisData = [];

      data.forEach((element) => {
        let formatterData = that.cityPullLineDataFormatter(element.data);
        let subData;

        content.forEach((content_ele) => {
          if (content_ele == "raw") {
            subData = formatterData.raw;
          } else {
            subData = formatterData.data;
          }

          axisData.push(...formatterData.axisData);
          let name = element.city;
          if (content.length > 1) {
            if (content_ele != "raw") {
              name = name + "(调整后)";
            }
          }

          series.push({
            type: "line",
            symbolSize: 10,
            name: name,
            label: {
              show: false,
              position: "top",
              formatter: function (params) {
                return params.data[1];
              },
            },
            data: subData,
          });
        });
      });

      axisData = Array.from(new Set(axisData));
      axisData = axisData.sort((a, b) => {
        let a_year = a[0];
        let a_season = a[1];

        let b_year = b[0];
        let b_season = b[1];

        if (a_year > b_year) {
          return 1;
        } else if (a_year == b_year) {
          if (a_season < b_season) {
            return -1;
          } else {
            return 1;
          }
        }

        return -1;
      });

      let axisDataZH = [];
      let seasonZh = ["春", "夏", "秋", "冬"];
      axisData.forEach((element) => {
        let year = element[0];
        let season = element[1];
        axisDataZH.push(year + "" + seasonZh[season]);
      });

      let st = getPullStand(pull);

      // let st = "A";
      let title;
      if (content.length > 1) {
        title = pull + "各季度经气象调整前后浓度变化";
      } else if (content[0] == "raw") {
        title = pull + "各季度原始浓度变化";
      } else {
        title = pull + "经气象调整后各季度浓度变化";
      }
      let option = {
        title: {
          text: title,
          left: "center",
          padding: 25,
        },

        grid: {
          top: 80 + data.length * 2,
          left: 30,
          right: 20,
          containLabel: true,
        },
        legend: { top: 50, right: "center" },
        tooltip: {
          trigger: "axis",
          position: "right",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: axisDataZH,
          axisLabel: {
            // rotate: 90,
            rotate: 0,
          },
        },
        yAxis: {
          type: "value",
          name: st,
          nameLocation: "middle",
          nameTextStyle: {
            padding: 15,
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            // startValue: data.length - 16,
            // endValue: data.length,
          },
        ],
        series: series,
      };

      chart.setOption(option, {
        notMerge: true,
      });
      chart.resize();
      chart.hideLoading();
    },

    cityPullLineDataFormatter(data) {
      var pullDens = [];
      var pullRawDens = [];
      let axisData = [];
      let seasonZh = ["春", "夏", "秋", "冬"];
      data.forEach((element) => {
        pullDens.push([
          element[2] + seasonZh[parseInt(element[3]) - 1],
          parseFloat(element[5]).toFixed(2),
        ]);

        pullRawDens.push([
          element[2] + seasonZh[parseInt(element[3]) - 1],
          parseFloat(element[4]).toFixed(2),
        ]);

        axisData.push([parseInt(element[2]), parseInt(element[3] - 1)]);
      });

      return {
        data: pullDens,
        raw: pullRawDens,
        axisData: axisData,
      };
    },

    drawCityPullRankChart(chart, data, pull, content = ["raw"]) {
      var pullDens = [];
      let seasonZh = ["春", "夏", "秋", "冬"];

      let series = [];
      let axisData = [];

      data.forEach((element) => {
        content.forEach((content_elm) => {
          let city = element.city;
          let city_data;
          if (content_elm == "raw") {
            city_data = element.raw;
          } else {
            city_data = element.data;
          }
          let pullData = [];

          city_data.forEach((elem) => {
            pullData.push([
              elem[1] + seasonZh[elem[2] - 1],
              parseFloat(elem[3]).toFixed(0),
            ]);

            axisData.push(elem[1] + "" + (elem[2] - 1));
          });

          let name = element.city;
          if (content_elm != "raw" && content.length > 1) {
            name = name + "（调整后）";
          }

          series.push({
            name: name,
            type: "bar",
            symbolSize: 10,
            label: {
              show: true,
              position: "top",
            },
            edgeSymbol: ["circle", "arrow"],
            edgeSymbolSize: [4, 10],
            data: pullData,
          });
        });
      });

      axisData = Array.from(new Set(axisData));
      axisData = axisData.sort((a, b) => {
        let a_year = a.substring(0, 4);
        let a_season = a.substring(4, 5);

        let b_year = b.substring(0, 4);
        let b_season = b.substring(4, 5);
        // console.log(a_season);

        if (a_year > b_year) {
          return 1;
        } else if (a_year == b_year) {
          if (a_season < b_season) {
            return -1;
          } else {
            return 1;
          }
        }

        return -1;
      });

      let axisDataZH = [];
      axisData.forEach((element) => {
        let year = element.substring(0, 4);
        let season = element.substring(4, 5);
        axisDataZH.push(year + "" + seasonZh[season]);
      });

      // 展示的年份数量
      let endValue = 1;
      let all_length = data.length;
      for (endValue = 1; endValue < 24; endValue++) {
        if (endValue * all_length > 40) {
          break;
        }
      }

      let title;
      // if (content == "raw") {
      //   title = pull + "各季度原始浓度排名";
      // } else {
      //   title = pull + "经气象调整后各季度浓度排名";
      // }

      if (content.length > 1) {
        title = pull + "各季度经气象调整前后浓度排名变化";
      } else if (content[0] == "raw") {
        title = pull + "各季度原始浓度排名变化";
      } else {
        title = pull + "经气象调整后各季度浓度排名变化";
      }

      let option = {
        title: {
          text: title,
          subtext: "排名数值越小，污染越低",
          left: "center",
          padding: 25,
          subtextStyle: {
            color: "#F56C6C",
            fontSize: "14",
          },
        },
        grid: {
          top: 125,
          left: 30,
          right: 20,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          position: "right",
        },
        legend: { top: 70, right: "center" },
        xAxis: {
          type: "category",
          // boundaryGap: false,
          data: axisDataZH,
          axisLabel: {
            rotate: 0,
          },
        },
        yAxis: {
          type: "value",
          name: "排名",
          nameLocation: "middle",
          nameTextStyle: {
            padding: 15,
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            startValue: axisDataZH.length - endValue,
            endValue: axisDataZH.length,
          },
        ],
        series: series,
      };

      chart.setOption(option, {
        notMerge: true,
      });
      chart.resize();
      chart.hideLoading();
    },
  },
  computed: {},

  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    assesscity: function (newAssesscity, oldAssesscity) {
      this.assesscity = newAssesscity;
      if (this.show) {
        this.chart_line_data = [];
        this.chart_rank_data = [];
        this.updatePullCharts();
      }
    },

    show: function (newShow, oldShow) {
      this.show = newShow;
      if (this.show) {
        this.chart.forEach((element) => {
          element.dispose();
        });
        this.chart = [];

        this.chart.push(
          this.$echarts.init(document.getElementById("city-pull-chart"))
        );
        // this.chart.push(
        //   this.$echarts.init(document.getElementById("city-pull-rank-chart"))
        // );

        this.chart.forEach((element) => {
          element.showLoading();
        });

        this.updatePullCharts();
      } else {
        this.chart.forEach((element) => {
          element.clear();
        });
      }
    },
  },
  created() {},
  mounted() {
    const that = this;

    if (this.show) {
      this.chart.push(
        this.$echarts.init(document.getElementById("city-pull-chart"))
      );
      // this.chart.push(
      //   this.$echarts.init(document.getElementById("city-pull-rank-chart"))
      // );

      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.updatePullCharts();
    }

    window.addEventListener("resize", () => {
      that.chart[0].resize();
      that.chart[1].resize();
    });
  },
};
</script>



